// src/pages/AllTestsCompletePage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FORM_REDIRECT_STORAGE_KEY = 'emotionSurveyFormRedirected';

const clearLegacyRedirectFlag = () => {
  try {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.removeItem(FORM_REDIRECT_STORAGE_KEY);
    }
  } catch (error) {
    // Ignore sessionStorage access issues
  }
};

function AllTestsCompletePage({ handleLogout }) {
  const navigate = useNavigate();

  const [hasRedirected, setHasRedirected] = useState(false);
  const [hasClearedSession, setHasClearedSession] = useState(false);

  useEffect(() => {
    const soundCompleted = localStorage.getItem('emotionSurveySoundTestCompleted') === 'true';
    const silentCompleted = localStorage.getItem('emotionSurveySilentTestCompleted') === 'true';
    const anyCompleted = soundCompleted || silentCompleted;

    if (!anyCompleted) {
      clearLegacyRedirectFlag();
      navigate('/test-selection', { replace: true });
      return;
    }

    if (!hasClearedSession) {
      clearLegacyRedirectFlag();
      if (typeof handleLogout === 'function') {
        handleLogout();
      }
      setHasClearedSession(true);
    }

    if (!hasRedirected) {
      setHasRedirected(true);
      window.location.replace('https://forms.gle/JBZevk4rQKKxT697A');
    }
  }, [hasClearedSession, hasRedirected, handleLogout, navigate]);

  const handleSessionClear = () => {
    clearLegacyRedirectFlag();
    setHasClearedSession(true);

    if (typeof handleLogout === 'function') {
      handleLogout();
    }
    navigate('/', { replace: true });
  };


  return (
    <div className="page-container all-tests-complete-page">
      <h2>Тест успешно пройден</h2>
      <p>
        Спасибо за участие! Если Google Форма не открылась автоматически, вы можете
        перейти по ссылке{' '}
        <a href="https://forms.gle/JBZevk4rQKKxT697A" target="_blank" rel="noreferrer">
          https://forms.gle/JBZevk4rQKKxT697A
        </a>
        .
      </p>
      <p>
        Для нового прохождения очистите данные текущей сессии с помощью кнопки ниже.
      </p>
      <button onClick={handleSessionClear} className="app-header-button logout-button">
        Очистить сессию
      </button>
    </div>
  );
}

export default AllTestsCompletePage;